import {
  isEqual
} from 'lodash';
import {
  NOT,
  YES
} from '../Boolean.lib';
import Core from '../Core';
import {
  Obj
} from '../Object.lib';
import {
  COLLECTION__ENGAGEMENTS,
  readLoopbackRecord
} from '../services/BE/loopback.api';

export default async function verifyEngagementIntegrity({
  engagement,
  update
}) {
  try {
    const FIELDS_TO_UPDATE = Object.keys(update);
    const liveEngagement = Obj(
      await readLoopbackRecord({
        collection: COLLECTION__ENGAGEMENTS,
        where: { id: engagement.id },
        fields: FIELDS_TO_UPDATE,
        limit: 1
      })
    );
    FIELDS_TO_UPDATE.forEach(field => {
      if (
        YES(liveEngagement[field]) && YES(engagement[field])
        && NOT(isEqual(liveEngagement[field], engagement[field]))
      ) {
        console.debug('verifyEngagementIntegrity', {
          FIELDS_TO_UPDATE,
          field,
          liveEngagement: liveEngagement[field],
          engagement: engagement[field]
        });
        throw new Error('The information displayed is outdated. Please refresh the page');
      }
    });
  }
  catch (error) {
    Core.showError(error);
    return false;
  }
  return true;
}
